import {
  actions,
  getAllContentEntityAudiosAsync,
  // addAudioAsync,
  // updateAudioAsync,
  // setDefaultAudioAsync,
  // removeAudioAsync,
  downloadAudioAsync,
} from './slices';

export const ContentEntityAudiosActions = {
  ...actions,
  getAllContentEntityAudiosAsync,
  // addAudioAsync,
  // updateAudioAsync,
  // setDefaultAudioAsync,
  // removeAudioAsync,
  downloadAudioAsync,
};
